export default __webpack_public_path__ + "static/media/giIconDark.9a42052c.svg";